import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
/* empty css                                                                               */
import { createElementBlock, createElementVNode, createTextVNode, openBlock } from "vue";
//#region src/components/LoadingOpenAPISpecsSummary.vue
var _sfc_main = {};
var _hoisted_1 = { class: "loadingApiSpecs" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("div", { class: "playIcon" }, null, -1), createTextVNode(" Loading APIs... ", -1)])]);
}
var LoadingOpenAPISpecsSummary_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-0248d9dc"]]);
//#endregion
export { LoadingOpenAPISpecsSummary_default as default };

//# sourceMappingURL=LoadingOpenAPISpecsSummary.vue.js.map